module.exports = __webpack_public_path__ + "static/doyaji_movie_mini-f6288eed93887659120c10708813a6c2.mp4";